var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6389 0H3.36111C1.50761 0 0 1.50822 0 3.36111V18.6389C0 20.4918 1.50761 22 3.36111 22H18.6389C20.4924 22 22 20.4918 22 18.6389V3.36111C22 1.50822 20.4924 0 18.6389 0ZM18.3333 11.3056C18.3333 11.8116 17.9233 12.2222 17.4167 12.2222C16.9101 12.2222 16.5 11.8116 16.5 11.3056V6.79617L7.06506 16.2317C6.886 16.4108 6.65133 16.5 6.41667 16.5C6.182 16.5 5.94733 16.4108 5.76828 16.2317C5.41017 15.8736 5.41017 15.2937 5.76828 14.9356L15.2038 5.5H10.6944C10.1878 5.5 9.77778 5.08933 9.77778 4.58333C9.77778 4.07733 10.1878 3.66667 10.6944 3.66667H17.4167C17.9233 3.66667 18.3333 4.07733 18.3333 4.58333V11.3056Z",
    fill: "#0078E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.aa75ef62d0eae99846c40049820b1dc3.svg";
export { ForwardRef as ReactComponent };